export const LAYOUT_FILTER_FIELD = 'layoutView';

export const UI_ONLY_FILTERS = [LAYOUT_FILTER_FIELD];

export function isUiOnlyFilter(fieldName) {
  return UI_ONLY_FILTERS.includes(fieldName);
}

export const LOCATION_FILTER_FIELD = 'location';
export const LOCATION_DISTANCE_FILTER_FIELD = 'locationDistance';

// The location search acts as part of the search (like the keyword), so its
// filters never show as "Applied filters" chips even though they are still
// sent to the API (unlike UI_ONLY_FILTERS, which are stripped from requests).
export const HIDDEN_APPLIED_FILTER_FIELDS = [
  LOCATION_FILTER_FIELD,
  LOCATION_DISTANCE_FILTER_FIELD,
];

export function isHiddenAppliedFilter(fieldName) {
  return HIDDEN_APPLIED_FILTER_FIELDS.includes(fieldName);
}

// "Clear all filters" keeps the layout and the location search (the latter is
// part of the search itself, like the keyword).
export const CLEAR_ALL_PRESERVED_FILTERS = [
  LAYOUT_FILTER_FIELD,
  LOCATION_FILTER_FIELD,
  LOCATION_DISTANCE_FILTER_FIELD,
];
